/*
 *  -----------------------------------------------------------------------
 *    <copyright file="snapshots/snapshots-grid.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React from 'react';

import { useTranslation } from 'hooks';
import ExpandableGrid from 'views/components/core/expandable/grid';

const SnapshotsGrid = ({ snapshots, rowActions }: any) => {
    const { t } = useTranslation();

    return (
        <ExpandableGrid
            customKey="snapshots"
            items={snapshots}
            detail={null}
            showPager
            groupable={false}
            scrollable="scrollable"
            reorderable
            pageable={false}
            resizable
            addScroll
            options={{
                allowExcelExport: false,
                allowExpandCollapseAll: false,
                useFilterChips: false,
            }}
            columns={[
                {
                    label: t('name'),
                    id: 'snapshot-name',
                    field: 'name',
                    minWidth: 270,
                },
            ]}
            rowActions={rowActions}
        />
    );
};

export default SnapshotsGrid;
